import takeRight from 'lodash/takeRight';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  error: null,
  isClosed: false,
  errors: [],
};

const CACHE_SIZE = 20;

const slice = createSlice({
  name: 'errors',
  initialState,
  reducers: {
    create: (state, action) => ({
      ...state,
      error: action.payload.message ? action.payload : null,
      isClosed: false,
      cache: takeRight([...state.errors, action.payload], CACHE_SIZE),
    }),
    close: (state, action) => ({
      ...state,
      isClosed: true,
    }),
    reset: (state, action) => ({
      ...initialState,
    }),
  },
});

export const { create, close, reset } = slice.actions;

export default slice.reducer;
